// @flow strict

import React from 'react';

import { Grid, Box } from '@material-ui/core';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Author } from '~components/author/author';

import type { PostNode } from '~types/post';

import * as styles from './search-result.module.less';

/**
 * Type of component properties
 */
type SearchResultProps = {
  post: PostNode,
};

/**
 * Render a single search result (blog post).
 *
 * @param {SearchResultProps} props - component properties
 *
 * @returns {Node}
 */
export const SearchResult = ({ post }: SearchResultProps) => {
  const {
    excerpt,
    timeToRead,
    fields: { authors },
    frontmatter: { title, date, permalink, thumbnail },
  } = post;

  const hasThumbnail = thumbnail != null;

  return (
    <div className={styles.searchResult}>
      <Grid container spacing={4}>
        {/* Blog post preview image - Hide on mobile */}
        {hasThumbnail && (
          <Box
            item
            sm={4}
            component={Grid}
            display={{ xs: 'none', sm: 'block' }}
          >
            <Link to={permalink}>
              <GatsbyImage
                image={thumbnail.childImageSharp.gatsbyImageData}
                alt="Preview Image"
              />
            </Link>
          </Box>
        )}

        {/* Blog post content preview */}
        <Grid item sm={hasThumbnail ? 8 : 12} xs={12}>
          <Link to={permalink}>
            <h1 className={styles.headline}>{title}</h1>
            <p className={styles.excerpt}>{excerpt}</p>
          </Link>

          <Author
            size="small"
            authors={authors}
            date={date}
            timeToRead={timeToRead}
          />
        </Grid>
      </Grid>
    </div>
  );
};
